import { useMutation } from "@apollo/client";

import { ResetPasswordMutation, ResetPasswordMutationVariables } from "@ctypes";
import { RESET_PASSWORD } from "@graphql";

export const useResetPassword = () => {
  return useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(RESET_PASSWORD);
};
